// extracted by mini-css-extract-plugin
module.exports = {"collaboration":"Collaboration_collaboration__2viKP","pageTitle":"Collaboration_pageTitle__3brAj","imageWrap":"Collaboration_imageWrap__360-S"};